<template>
  <v-autocomplete
    outlined
    hide-details
    clearable
    return-object
    no-filter
    hide-selected
    hide-no-data
    item-text="descricao"
    label="Projeto"
    v-model="localValue"
    :items="items"
    :loading="loading"
    :search-input.sync="search"
    @blur="onBlur"
    @focus="onFocus"
    v-bind="$attrs">
    <template v-slot:item="item">
      <v-list-item-content>
        <v-list-item-title>
          <px-chip-codigo-interno :codigo-interno="item.item.codigoInterno"/>
          {{ item.item.descricao }}
        </v-list-item-title>
      </v-list-item-content>
    </template>
    <template v-slot:selection="item">
      <div class="truncate-text">
        <px-chip-codigo-interno :codigo-interno="item.item.codigoInterno"/>
        {{ item.item.descricao }}
      </div>
    </template>
  </v-autocomplete>
</template>

<script>
import { debounce } from 'vuetify/lib/util/helpers';
import ProjetoService from '@/api/projeto-service';

const DEFAULT_LIMIT = 100;
const DEFAULT_OFFSET = 0;

export default {
  props: {
    value: Object,
  },
  data() {
    return {
      loading: false,
      items: [],
      model: null,
      search: null,
      debounceSearch: null,
    };
  },
  computed: {
    localValue: {
      get() { return this.value; },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
  },
  watch: {
    search(val) {
      if (!val || (this.localValue && this.localValue.descricao === val)) return;
      this.debounceSearch(val);
    },
    value() {
      if (this.value) {
        this.items = [...this.items, this.value];
      }
    },
  },
  methods: {
    searchItems(val) {
      const searchValue = val || '';

      this.loading = true;
      ProjetoService.getProjetos({
        limit: DEFAULT_LIMIT,
        offset: DEFAULT_OFFSET,
        query: `ativo is true and (descricao like "%${searchValue.toLowerCase()}%" or codigoInterno like "%${searchValue.toLowerCase()}%")`,
      })
        .then((response) => {
          this.items = this.value ? [this.value, ...response.data.content] : response.data.content;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onBlur(event) {
      this.$emit('blur', event);
    },
    onFocus() {
    },
  },
  created() {
    this.debounceSearch = debounce(this.searchItems, 1000);
    if (this.value) {
      this.items = [this.value, ...this.items];
    }
  },
};
</script>
